import { orderBy } from 'lodash';

// Const
import { deviceType } from 'const/nuclias/device';
import { licenseConfig } from 'const/nuclias/license';
import { sharedDeviceModel } from './const';

// Service
import AuthDeviceService from 'services/Auth.Device.service';
import AuthLicenseService from 'services/Auth.License.service';

// Util
import licenseUtil from 'utils/license.util';

const getDeviceModel = async (orgId, deviceUid) => {
  const response = await AuthDeviceService.getDeviceModel(orgId, deviceUid);
  return response;
}

const parseRawDeviceModel = (rawData, deviceUid, allDeviceList) => {
  let modelName = rawData.modelName;
  let deviceName = '';
  const defaultLicense = {
    key: null,
    period: null,
    unit: null,
    unitLabel: null
  };
  let restrictCountryCode = null;

  // Shared device model name that device shares the same model
  for (const key in sharedDeviceModel) {
    sharedDeviceModel[key].indexOf(modelName) > -1 && (modelName = key);
  }

  // Device name
  for (const device of allDeviceList) {
    (device.uid === deviceUid) && (deviceName = device.name)
  }

  // Default license
  if (rawData.period > 0) {
    defaultLicense.key = rawData.defaultLicense;
    defaultLicense.period = rawData.period;
    defaultLicense.unit = rawData.unit;

    switch (defaultLicense.unit) {
      case licenseConfig.termUnit.year:
        defaultLicense.unitLabel = '537c66b24e'
        break;
      case licenseConfig.termUnit.month:
        defaultLicense.unitLabel = '7cbb885aa1'
        break;
      case licenseConfig.termUnit.day:
        defaultLicense.unitLabel = '03727ac485'
        break;
      default:
        return;
    }
  }

  // Restrict country
  if (rawData.restrictCountryCode) {
    restrictCountryCode = rawData.restrictCountryCode.toLowerCase();
  }

  return {
    modelName,
    deviceName,
    defaultLicense,
    restrictCountryCode
  }
}

const getLicenseList = async (orgId, modelName) => {
  let licenseDeviceType = deviceType.ap;
  modelName.indexOf('DBS') > -1 && (licenseDeviceType = deviceType.switch);
  modelName.indexOf('DBG') > -1 && (licenseDeviceType = deviceType.gateway);

  const fetchOption = {
    limit: 10,
    total: 0,
    orderByRemaning: 'ASC',
    hasMore: true
  };

  const payload = {
    organizationId: orgId,
    bindDevice: false,
    skip: 0,
    limit: fetchOption.limit,
    orderByRemaning: fetchOption.orderByRemaning,
    licenseDeviceType: licenseDeviceType
  }

  let list = [];
  const get = async () => {
    try {
      const response = await AuthLicenseService.getLicense(payload);

      if (response.error) {
        throw response;
      }

      list = list.concat(response.data);

      if (list.length !== response.total) {
        payload.skip = list.length;
        get();
      }

      return list;
    } catch (response) {
      return response;
    }
  }

  try {
    const response = await get();

    if (response.error) {
      throw response;
    }

    return list;
  } catch (response) {
    return response;
  }
}

const parseRawLicenseList = (rawData) => {
  const stateType = {
    unusedInactived: 'unusedInactived',
    unusedActived: 'unusedActived'
  };
  let unusedActivedLicenseCount = 0;

  const checkState = (state, startDate) => {
    if (state === licenseConfig.state['AVAILABLE'] && !startDate) {
      return stateType.unusedInactived;
    }

    // (state === licenseConfig.state['AVAILABLE'] && startDate)
    // (state === licenseConfig.state['WAIT_FOR_RESUME'])
    return stateType.unusedActived;
  }

  let list = [];
  for (const license of rawData) {
    if (
      license.state !== licenseConfig.state['AVAILABLE'] &&
      license.state !== licenseConfig.state['SUSPENDED_WAIT_FOR_RESUME']
    ) {
      return;
    }

    const updatedLicense = licenseUtil.getLicenseRemainDate(license);
    const state = checkState(license.state, license.startDate);

    if (state === stateType.unusedActived) {
      unusedActivedLicenseCount++;
    }

    list.push({
      key: license.key,
      deviceType: license.deviceType,
      remainDayCount: updatedLicense.remainDayCount,
      remainDayLabel: updatedLicense.remainDayUnit,
      state
    });
  }

  list = orderBy(list, ['remainDayCount'], ['asc']);

  return {
    unusedActivedLicenseCount,
    list
  };
}

const checkLicenseLength = (value) => {
  return value.length === licenseConfig.length || value.length === licenseConfig.freeLength;
}

const registerDevice = async (orgId, addDeviceState) => {
  const payload = {
    organizationId: orgId,
    uid: addDeviceState.deviceUid.value,
    deviceGroupId: addDeviceState.profile.selected.id,
    storeId: addDeviceState.site.selected.id,
    licenseKey: ''
  };

  const licenseKeyList = [];
  addDeviceState.licenseKeyList.defaultLicense.key && licenseKeyList.push(addDeviceState.licenseKeyList.defaultLicense.key);
  for (const index in addDeviceState.licenseKeyList.valueList) {
    const licenseKey = addDeviceState.licenseKeyList.valueList[index];
    licenseKey.valid && licenseKeyList.push(licenseKey.key);
  }
  payload.licenseKey = licenseKeyList.join(',');

  const response = await AuthDeviceService.registerDevice(payload);
  return response;
}

export default {
  getDeviceModel,
  parseRawDeviceModel,
  getLicenseList,
  parseRawLicenseList,
  checkLicenseLength,
  registerDevice
}